import { Box, Typography } from "@mui/material";
import { ArrowLeft } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import PropTypes from "prop-types";
import { useState } from "react";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { parentNavigate } from "../../controllers/ParentNavigate";
import GetCategoryMetaField from "./GetCategoryMetaField";
import GetCheckOutMetaField from "./GetCheckOutMetaField";
import GetManufactureMetaField from "./GetManufactureMetaField";
import GetPageMetaField from "./GetPageMetaField";
import GetPortfolioMetaField from "./GetPortfolioMetaField";
import GetProductMetaField from "./GetProductMetaField";
import GetRegisterMetaField from "./GetRegisterMetaField";
import GetVariantMetaField from "./GetVariantMetaField";
import GetBlogMetaField from "./GetBlogMetaField";
import { ButtonComponent, SelectComponent } from "@shopeasy-dashboard-ui/ui-library";

const ListMetaFieldGroup = () => {
  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  };

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  const [openTab, setOpenTab] = useState("Products");

  const menuItems = [
    {
      key: "Products",
      label: t("lang_products"),
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mr-3"
        >
          <g clip-path="url(#clip0_267_5263)">
            <path
              d="M6.47662 1.20486C6.54001 1.24282 6.5953 1.2929 6.63934 1.35223C6.68337 1.41156 6.71528 1.47898 6.73325 1.55065C6.75122 1.62232 6.75489 1.69682 6.74406 1.76991C6.73323 1.843 6.70811 1.91324 6.67013 1.97661L3.80587 6.74999H14.1941L11.3287 1.97661C11.2521 1.84861 11.2294 1.69539 11.2657 1.55066C11.302 1.40593 11.3942 1.28154 11.5222 1.20486C11.6502 1.12818 11.8035 1.10549 11.9482 1.14178C12.0929 1.17806 12.2173 1.27036 12.294 1.39836L15.5059 6.74999H17.4375C17.5867 6.74999 17.7298 6.80925 17.8352 6.91474C17.9407 7.02023 18 7.1633 18 7.31249V8.43749C18 8.58667 17.9407 8.72974 17.8352 8.83523C17.7298 8.94072 17.5867 8.99999 17.4375 8.99999H0.5625C0.413316 8.99999 0.270242 8.94072 0.164752 8.83523C0.0592632 8.72974 0 8.58667 0 8.43749V7.31249C0 7.1633 0.0592632 7.02023 0.164752 6.91474C0.270242 6.80925 0.413316 6.74999 0.5625 6.74999H2.49412L5.70375 1.39836C5.74171 1.33497 5.79178 1.27968 5.85112 1.23565C5.91045 1.19162 5.97787 1.1597 6.04954 1.14174C6.12121 1.12377 6.19571 1.12009 6.2688 1.13092C6.34189 1.14176 6.41325 1.16688 6.47662 1.20486ZM2.7765 17.3542L1.06088 10.125H16.9391L15.2235 17.3542C15.1791 17.5383 15.074 17.702 14.9253 17.8192C14.7765 17.9363 14.5927 18 14.4034 18H3.59663C3.4071 18.0002 3.22302 17.9366 3.07404 17.8195C2.92505 17.7024 2.82097 17.5385 2.7765 17.3542Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_267_5263">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    // {
    //   key: "Variants",
    //   label: t("lang_variants"),
    //   icon: (
    //     <svg
    //       width="18"
    //       height="18"
    //       viewBox="0 0 18 18"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //       className="mr-3"
    //     >
    //       <path
    //         d="M1.125 3.9375C1.125 3.78832 1.18426 3.64524 1.28975 3.53975C1.39524 3.43426 1.53832 3.375 1.6875 3.375H16.3125C16.4617 3.375 16.6048 3.43426 16.7102 3.53975C16.8157 3.64524 16.875 3.78832 16.875 3.9375V5.0625C16.875 5.21168 16.8157 5.35476 16.7102 5.46025C16.6048 5.56574 16.4617 5.625 16.3125 5.625H1.6875C1.53832 5.625 1.39524 5.56574 1.28975 5.46025C1.18426 5.35476 1.125 5.21168 1.125 5.0625V3.9375ZM1.125 8.4375C1.125 8.28832 1.18426 8.14524 1.28975 8.03975C1.39524 7.93426 1.53832 7.875 1.6875 7.875H7.3125C7.46168 7.875 7.60476 7.93426 7.71025 8.03975C7.81574 8.14524 7.875 8.28832 7.875 8.4375V9.5625C7.875 9.71168 7.81574 9.85476 7.71025 9.96025C7.60476 10.0657 7.46168 10.125 7.3125 10.125H1.6875C1.53832 10.125 1.39524 10.0657 1.28975 9.96025C1.18426 9.85476 1.125 9.71168 1.125 9.5625V8.4375ZM1.125 12.9375C1.125 12.7883 1.18426 12.6452 1.28975 12.5398C1.39524 12.4343 1.53832 12.375 1.6875 12.375H2.8125C2.96168 12.375 3.10476 12.4343 3.21025 12.5398C3.31574 12.6452 3.375 12.7883 3.375 12.9375V14.0625C3.375 14.2117 3.31574 14.3548 3.21025 14.4602C3.10476 14.5657 2.96168 14.625 2.8125 14.625H1.6875C1.53832 14.625 1.39524 14.5657 1.28975 14.4602C1.18426 14.3548 1.125 14.2117 1.125 14.0625V12.9375ZM10.125 12.9375C10.125 12.7883 10.1843 12.6452 10.2898 12.5398C10.3952 12.4343 10.5383 12.375 10.6875 12.375H11.8125C11.9617 12.375 12.1048 12.4343 12.2102 12.5398C12.3157 12.6452 12.375 12.7883 12.375 12.9375V14.0625C12.375 14.2117 12.3157 14.3548 12.2102 14.4602C12.1048 14.5657 11.9617 14.625 11.8125 14.625H10.6875C10.5383 14.625 10.3952 14.5657 10.2898 14.4602C10.1843 14.3548 10.125 14.2117 10.125 14.0625V12.9375ZM5.625 12.9375C5.625 12.7883 5.68426 12.6452 5.78975 12.5398C5.89524 12.4343 6.03832 12.375 6.1875 12.375H7.3125C7.46168 12.375 7.60476 12.4343 7.71025 12.5398C7.81574 12.6452 7.875 12.7883 7.875 12.9375V14.0625C7.875 14.2117 7.81574 14.3548 7.71025 14.4602C7.60476 14.5657 7.46168 14.625 7.3125 14.625H6.1875C6.03832 14.625 5.89524 14.5657 5.78975 14.4602C5.68426 14.3548 5.625 14.2117 5.625 14.0625V12.9375ZM14.625 12.9375C14.625 12.7883 14.6843 12.6452 14.7898 12.5398C14.8952 12.4343 15.0383 12.375 15.1875 12.375H16.3125C16.4617 12.375 16.6048 12.4343 16.7102 12.5398C16.8157 12.6452 16.875 12.7883 16.875 12.9375V14.0625C16.875 14.2117 16.8157 14.3548 16.7102 14.4602C16.6048 14.5657 16.4617 14.625 16.3125 14.625H15.1875C15.0383 14.625 14.8952 14.5657 14.7898 14.4602C14.6843 14.3548 14.625 14.2117 14.625 14.0625V12.9375ZM10.125 8.4375C10.125 8.28832 10.1843 8.14524 10.2898 8.03975C10.3952 7.93426 10.5383 7.875 10.6875 7.875H16.3125C16.4617 7.875 16.6048 7.93426 16.7102 8.03975C16.8157 8.14524 16.875 8.28832 16.875 8.4375V9.5625C16.875 9.71168 16.8157 9.85476 16.7102 9.96025C16.6048 10.0657 16.4617 10.125 16.3125 10.125H10.6875C10.5383 10.125 10.3952 10.0657 10.2898 9.96025C10.1843 9.85476 10.125 9.71168 10.125 9.5625V8.4375Z"
    //         fill={openTab === "Variants" ? "#000000" : "#666666"}
    //       />
    //     </svg>
    //   ),
    // },
    {
      key: "Category",
      label: t("lang_category"),
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mr-3"
        >
          <g clip-path="url(#clip0_267_5288)">
            <path
              d="M9 16.875V1.125H15.75C16.0484 1.125 16.3345 1.24353 16.5455 1.4545C16.7565 1.66548 16.875 1.95163 16.875 2.25V15.75C16.875 16.0484 16.7565 16.3345 16.5455 16.5455C16.3345 16.7565 16.0484 16.875 15.75 16.875H9ZM15.75 18C16.3467 18 16.919 17.7629 17.341 17.341C17.7629 16.919 18 16.3467 18 15.75V2.25C18 1.65326 17.7629 1.08097 17.341 0.65901C16.919 0.237053 16.3467 0 15.75 0L2.25 0C1.65326 0 1.08097 0.237053 0.65901 0.65901C0.237053 1.08097 0 1.65326 0 2.25L0 15.75C0 16.3467 0.237053 16.919 0.65901 17.341C1.08097 17.7629 1.65326 18 2.25 18H15.75Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_267_5288">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      key: "Manufacture",
      label: t("lang_Manufacture"),
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mr-3"
        >
          <path
            d="M16.875 0.562481C16.875 0.466559 16.8505 0.372231 16.8037 0.288462C16.757 0.204693 16.6896 0.134266 16.608 0.0838741C16.5264 0.0334821 16.4332 0.00479935 16.3374 0.000551828C16.2416 -0.00369569 16.1463 0.0166331 16.0605 0.0596062L7.0605 4.55961C6.96718 4.60637 6.88872 4.67817 6.83388 4.76698C6.77905 4.85579 6.75 4.95811 6.75 5.06248V8.59498L0.38475 10.7167C0.272788 10.754 0.17539 10.8256 0.106341 10.9213C0.0372916 11.017 8.96026e-05 11.132 0 11.25L0 17.4375C0 17.5867 0.0592632 17.7297 0.164752 17.8352C0.270242 17.9407 0.413316 18 0.5625 18H10.6875C10.8367 18 10.9798 17.9407 11.0852 17.8352C11.1907 17.7297 11.25 17.5867 11.25 17.4375V15.75H12.375V17.4375C12.375 17.5867 12.4343 17.7297 12.5398 17.8352C12.6452 17.9407 12.7883 18 12.9375 18H16.3125C16.4617 18 16.6048 17.9407 16.7102 17.8352C16.8157 17.7297 16.875 17.5867 16.875 17.4375V0.562481ZM2.25 12.375H3.375V13.5H2.25V12.375ZM4.5 12.375H5.625V13.5H4.5V12.375ZM3.375 14.625V15.75H2.25V14.625H3.375ZM4.5 14.625H5.625V15.75H4.5V14.625ZM14.625 3.37498V4.49998H13.5V3.37498H14.625ZM9 5.62498H10.125V6.74998H9V5.62498ZM10.125 7.87498V8.99998H9V7.87498H10.125ZM9 10.125H10.125V11.25H9V10.125ZM11.25 10.125H12.375V11.25H11.25V10.125ZM10.125 12.375V13.5H9V12.375H10.125ZM11.25 12.375H12.375V13.5H11.25V12.375ZM14.625 10.125V11.25H13.5V10.125H14.625ZM13.5 12.375H14.625V13.5H13.5V12.375ZM11.25 7.87498H12.375V8.99998H11.25V7.87498ZM14.625 7.87498V8.99998H13.5V7.87498H14.625ZM12.375 5.62498V6.74998H11.25V5.62498H12.375ZM13.5 5.62498H14.625V6.74998H13.5V5.62498Z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      key: "Pages",
      label: t("lang_pages"),
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mr-3"
        >
          <path
            d="M4.5 0H10.4546C10.753 6.37171e-05 11.0391 0.118632 11.25 0.329625L15.4204 4.5C15.6314 4.71093 15.7499 4.99703 15.75 5.29537V15.75C15.75 16.3467 15.5129 16.919 15.091 17.341C14.669 17.7629 14.0967 18 13.5 18H4.5C3.90326 18 3.33097 17.7629 2.90901 17.341C2.48705 16.919 2.25 16.3467 2.25 15.75V2.25C2.25 1.65326 2.48705 1.08097 2.90901 0.65901C3.33097 0.237053 3.90326 0 4.5 0ZM10.6875 1.6875V3.9375C10.6875 4.23587 10.806 4.52202 11.017 4.733C11.228 4.94397 11.5141 5.0625 11.8125 5.0625H14.0625L10.6875 1.6875Z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    // {
    //   key: "Portfolio",
    //   label: t("lang_portfolio"),
    //   icon: (
    //     <svg
    //       width="18"
    //       height="18"
    //       viewBox="0 0 18 18"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //       className="mr-3"
    //     >
    //       <path
    //         d="M6.75 9C7.64511 9 8.50355 8.64442 9.13649 8.01149C9.76942 7.37855 10.125 6.52011 10.125 5.625C10.125 4.72989 9.76942 3.87145 9.13649 3.23851C8.50355 2.60558 7.64511 2.25 6.75 2.25C5.85489 2.25 4.99645 2.60558 4.36351 3.23851C3.73058 3.87145 3.375 4.72989 3.375 5.625C3.375 6.52011 3.73058 7.37855 4.36351 8.01149C4.99645 8.64442 5.85489 9 6.75 9ZM1.125 15.75C1.125 15.75 0 15.75 0 14.625C0 13.5 1.125 10.125 6.75 10.125C12.375 10.125 13.5 13.5 13.5 14.625C13.5 15.75 12.375 15.75 12.375 15.75H1.125ZM12.375 3.9375C12.375 3.78832 12.4343 3.64524 12.5398 3.53975C12.6452 3.43426 12.7883 3.375 12.9375 3.375H17.4375C17.5867 3.375 17.7298 3.43426 17.8352 3.53975C17.9407 3.64524 18 3.78832 18 3.9375C18 4.08668 17.9407 4.22976 17.8352 4.33525C17.7298 4.44074 17.5867 4.5 17.4375 4.5H12.9375C12.7883 4.5 12.6452 4.44074 12.5398 4.33525C12.4343 4.22976 12.375 4.08668 12.375 3.9375ZM12.9375 6.75C12.7883 6.75 12.6452 6.80926 12.5398 6.91475C12.4343 7.02024 12.375 7.16332 12.375 7.3125C12.375 7.46168 12.4343 7.60476 12.5398 7.71025C12.6452 7.81574 12.7883 7.875 12.9375 7.875H17.4375C17.5867 7.875 17.7298 7.81574 17.8352 7.71025C17.9407 7.60476 18 7.46168 18 7.3125C18 7.16332 17.9407 7.02024 17.8352 6.91475C17.7298 6.80926 17.5867 6.75 17.4375 6.75H12.9375ZM15.1875 10.125C15.0383 10.125 14.8952 10.1843 14.7898 10.2898C14.6843 10.3952 14.625 10.5383 14.625 10.6875C14.625 10.8367 14.6843 10.9798 14.7898 11.0852C14.8952 11.1907 15.0383 11.25 15.1875 11.25H17.4375C17.5867 11.25 17.7298 11.1907 17.8352 11.0852C17.9407 10.9798 18 10.8367 18 10.6875C18 10.5383 17.9407 10.3952 17.8352 10.2898C17.7298 10.1843 17.5867 10.125 17.4375 10.125H15.1875ZM15.1875 13.5C15.0383 13.5 14.8952 13.5593 14.7898 13.6648C14.6843 13.7702 14.625 13.9133 14.625 14.0625C14.625 14.2117 14.6843 14.3548 14.7898 14.4602C14.8952 14.5657 15.0383 14.625 15.1875 14.625H17.4375C17.5867 14.625 17.7298 14.5657 17.8352 14.4602C17.9407 14.3548 18 14.2117 18 14.0625C18 13.9133 17.9407 13.7702 17.8352 13.6648C17.7298 13.5593 17.5867 13.5 17.4375 13.5H15.1875Z"
    //         fill={openTab === "Portfolio" ? "#000000" : "#666666"}
    //       />
    //     </svg>
    //   ),
    // },
    {
      key: "Registration",
      label: t("lang_Registration"),
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mr-3"
        >
          <g clip-path="url(#clip0_267_5317)">
            <path
              d="M7.875 2.8125C7.875 2.66332 7.93426 2.52024 8.03975 2.41475C8.14524 2.30926 8.28832 2.25 8.4375 2.25H16.3125C16.4617 2.25 16.6048 2.30926 16.7102 2.41475C16.8157 2.52024 16.875 2.66332 16.875 2.8125V3.9375C16.875 4.08668 16.8157 4.22976 16.7102 4.33525C16.6048 4.44074 16.4617 4.5 16.3125 4.5H8.4375C8.28832 4.5 8.14524 4.44074 8.03975 4.33525C7.93426 4.22976 7.875 4.08668 7.875 3.9375V2.8125ZM5.02914e-08 13.5C5.02914e-08 12.6049 0.355579 11.7464 0.988515 11.1135C1.62145 10.4806 2.47989 10.125 3.375 10.125C4.27011 10.125 5.12855 10.4806 5.76149 11.1135C6.39442 11.7464 6.75 12.6049 6.75 13.5C6.75 14.3951 6.39442 15.2536 5.76149 15.8865C5.12855 16.5194 4.27011 16.875 3.375 16.875C2.47989 16.875 1.62145 16.5194 0.988515 15.8865C0.355579 15.2536 5.02914e-08 14.3951 5.02914e-08 13.5ZM7.875 11.8125C7.875 11.6633 7.93426 11.5202 8.03975 11.4148C8.14524 11.3093 8.28832 11.25 8.4375 11.25H16.3125C16.4617 11.25 16.6048 11.3093 16.7102 11.4148C16.8157 11.5202 16.875 11.6633 16.875 11.8125V12.9375C16.875 13.0867 16.8157 13.2298 16.7102 13.3352C16.6048 13.4407 16.4617 13.5 16.3125 13.5H8.4375C8.28832 13.5 8.14524 13.4407 8.03975 13.3352C7.93426 13.2298 7.875 13.0867 7.875 12.9375V11.8125ZM7.875 6.1875C7.875 6.03832 7.93426 5.89524 8.03975 5.78975C8.14524 5.68426 8.28832 5.625 8.4375 5.625H14.0625C14.2117 5.625 14.3548 5.68426 14.4602 5.78975C14.5657 5.89524 14.625 6.03832 14.625 6.1875C14.625 6.33668 14.5657 6.47976 14.4602 6.58525C14.3548 6.69074 14.2117 6.75 14.0625 6.75H8.4375C8.28832 6.75 8.14524 6.69074 8.03975 6.58525C7.93426 6.47976 7.875 6.33668 7.875 6.1875ZM7.875 15.1875C7.875 15.0383 7.93426 14.8952 8.03975 14.7898C8.14524 14.6843 8.28832 14.625 8.4375 14.625H14.0625C14.2117 14.625 14.3548 14.6843 14.4602 14.7898C14.5657 14.8952 14.625 15.0383 14.625 15.1875C14.625 15.3367 14.5657 15.4798 14.4602 15.5852C14.3548 15.6907 14.2117 15.75 14.0625 15.75H8.4375C8.28832 15.75 8.14524 15.6907 8.03975 15.5852C7.93426 15.4798 7.875 15.3367 7.875 15.1875ZM3.375 1.125C2.93179 1.125 2.49292 1.2123 2.08344 1.38191C1.67397 1.55152 1.30191 1.80012 0.988515 2.11351C0.675117 2.42691 0.426516 2.79897 0.256907 3.20844C0.0872969 3.61792 0 4.05679 0 4.5C0 4.94321 0.0872969 5.38208 0.256907 5.79156C0.426516 6.20103 0.675117 6.57309 0.988515 6.88649C1.30191 7.19988 1.67397 7.44848 2.08344 7.61809C2.49292 7.7877 2.93179 7.875 3.375 7.875C4.27011 7.875 5.12855 7.51942 5.76149 6.88649C6.39442 6.25355 6.75 5.39511 6.75 4.5C6.75 3.60489 6.39442 2.74645 5.76149 2.11351C5.12855 1.48058 4.27011 1.125 3.375 1.125ZM3.375 6.1875C2.92745 6.1875 2.49822 6.00971 2.18176 5.69324C1.86529 5.37678 1.6875 4.94755 1.6875 4.5C1.6875 4.05245 1.86529 3.62322 2.18176 3.30676C2.49822 2.99029 2.92745 2.8125 3.375 2.8125C3.82255 2.8125 4.25178 2.99029 4.56824 3.30676C4.88471 3.62322 5.0625 4.05245 5.0625 4.5C5.0625 4.94755 4.88471 5.37678 4.56824 5.69324C4.25178 6.00971 3.82255 6.1875 3.375 6.1875Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_267_5317">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      key: "Checkout",
      label: t("lang_Checkout"),
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mr-3"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.8125 3.9375C11.8125 3.19158 11.5162 2.47621 10.9887 1.94876C10.4613 1.42132 9.74592 1.125 9 1.125C8.25408 1.125 7.53871 1.42132 7.01126 1.94876C6.48382 2.47621 6.1875 3.19158 6.1875 3.9375V4.5H11.8125V3.9375ZM12.9375 3.9375V4.5H16.875V15.75C16.875 16.3467 16.6379 16.919 16.216 17.341C15.794 17.7629 15.2217 18 14.625 18H3.375C2.77826 18 2.20597 17.7629 1.78401 17.341C1.36205 16.919 1.125 16.3467 1.125 15.75V4.5H5.0625V3.9375C5.0625 2.89321 5.47734 1.89169 6.21577 1.15327C6.95419 0.414843 7.95571 0 9 0C10.0443 0 11.0458 0.414843 11.7842 1.15327C12.5227 1.89169 12.9375 2.89321 12.9375 3.9375ZM12.2108 9.96075C12.3164 9.85513 12.3757 9.71187 12.3757 9.5625C12.3757 9.41313 12.3164 9.26987 12.2108 9.16425C12.1051 9.05863 11.9619 8.99929 11.8125 8.99929C11.6631 8.99929 11.5199 9.05863 11.4142 9.16425L8.4375 12.1421L7.14825 10.8517C7.09595 10.7995 7.03386 10.758 6.96553 10.7297C6.8972 10.7014 6.82396 10.6868 6.75 10.6868C6.67604 10.6868 6.6028 10.7014 6.53447 10.7297C6.46614 10.758 6.40405 10.7995 6.35175 10.8517C6.29945 10.904 6.25797 10.9661 6.22966 11.0345C6.20136 11.1028 6.18679 11.176 6.18679 11.25C6.18679 11.324 6.20136 11.3972 6.22966 11.4655C6.25797 11.5339 6.29945 11.596 6.35175 11.6483L8.03925 13.3358C8.0915 13.3881 8.15357 13.4297 8.22191 13.4581C8.29025 13.4864 8.36351 13.501 8.4375 13.501C8.51149 13.501 8.58475 13.4864 8.65309 13.4581C8.72143 13.4297 8.7835 13.3881 8.83575 13.3358L12.2108 9.96075Z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      key: "Blog",
      label: t("lang_blog"),
      icon: (
        <svg
          width="18"
          height="18"
          fill="currentcolor"
          version="1.1"
          id="Icons"
          xmlns="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 32 32"
          space="preserve"
          className="mr-3"
        >
          <g>
            <path
              d="M17.8,18H15c-0.6,0-1-0.4-1-1v-2.8c0-0.3,0.1-0.5,0.3-0.7L24.9,2.9c0.2-0.2,0.4-0.3,0.7-0.3l0,0c0.3,0,0.5,0.1,0.7,0.3
l2.8,2.8c0.4,0.4,0.4,1,0,1.4L18.5,17.7C18.3,17.9,18.1,18,17.8,18z"
            ></path>
          </g>
          <path
            d="M19.9,19.1c-0.6,0.6-1.3,0.9-2.1,0.9H15c-1.7,0-3-1.3-3-3v-2.8c0-0.8,0.3-1.6,0.9-2.1L18.9,6H9C7.3,6,6,7.3,6,9v14
c0,1.7,1.3,3,3,3h14c1.7,0,3-1.3,3-3v-9.9L19.9,19.1z"
          ></path>
        </svg>
      ),
    },
  ];

  return (
    <div className="h-auto pb-[64px] p-5">
      {/* HEADER */}
      <div className="flex items-center justify-between w-full pb-4">
        <div className="flex items-center space-x-2">
          <ButtonComponent
            variant="ghost"
            size="sm"
            onClick={(e) => {
              e.preventDefault();
              parentNavigate("/dashboard");
            }}
            icon={<ArrowLeft />}
            className="back-arrow !p-1 text-[var(--primary-text-color)]"
          />
          <div>
            <Breadcrumbs
              crumbs={[
                { name: t("lang_dashboard"), path: `/dashboard` },
                { name: t("lang_customField"), path: "/custom-field" },
              ]}
            />
            <div className="flex items-end">
              <h4 className="text-xl md:text-2xl font-semibold text-primary">
                {t("lang_customField")}
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-0 sm:gap-4 items-start metaFieldgroupCustome w-full">
        {/* RESPONSIVE SELECT BOX USING SelectComponent (Mobile View) */}
        <div className="block sm:hidden w-full mb-2">
          <SelectComponent
            value={openTab}
            options={menuItems.map((item) => ({
              value: item.key,
              label: item.label,
            }))}
            onChange={(e) => setOpenTab(e.target.value)}
            searchable={false}
            formatOptionLabel={(option) => {
              const item = menuItems.find((m) => m.key === option.value);
              return (
                <div className="flex items-center text-sm font-medium">
                  {item?.icon}
                  <span>{option.label}</span>
                </div>
              );
            }}
          />
        </div>

        {/* LEFT MENU (Desktop View) */}
        <div className="metaFieldgroupCustome hidden sm:block w-full sm:w-[250px] lg:w-[280px] shrink-0">
          <ul className="w-full bg-white p-2 space-y-1 border main-border-color !rounded-xl min-h-[calc(100vh-200px)]">
            {menuItems.map((item) => {
              const active = openTab === item.key;

              return (
                <li
                  key={item.key}
                  onClick={() => setOpenTab(item.key)}
                  className={`flex items-center px-3 py-2 rounded-md cursor-pointer transition-colors duration-200
                   ${active ? "primary-bg-color text-primary" : "table-text"}`}
                >
                  {item.icon}
                  {item.label}
                </li>
              );
            })}
          </ul>
        </div>

        <div className="flex-1 min-w-0 w-full">
          <Box sx={{ flexGrow: 1, width: "100%", minHeight: "350px" }}>
            {openTab === "Products" ? (
              <GetProductMetaField />
            ) : openTab === "Variants" ? (
              <GetVariantMetaField />
            ) : openTab === "Category" ? (
              <GetCategoryMetaField />
            ) : openTab === "Manufacture" ? (
              <GetManufactureMetaField />
            ) : openTab === "Pages" ? (
              <GetPageMetaField />
            ) : openTab === "Portfolio" ? (
              <GetPortfolioMetaField />
            ) : openTab === "Registration" ? (
              <GetRegisterMetaField />
            ) : openTab === "Checkout" ? (
              <GetCheckOutMetaField />
            ) : openTab === "Blog" ? (
              <GetBlogMetaField />
            ) : (
              <></>
            )}
          </Box>
        </div>
      </div>
    </div>
  );
};

export default ListMetaFieldGroup;
